module.exports = SigecoTools;